import React, { useState, useEffect } from 'react';
import { createFromIconfontCN } from '@ant-design/icons';
import styles from './index.module.scss'
import { TabBar } from 'antd-mobile-v5'
import HomeContainer from './components/home';
import Tools from './components/Tools'  //一路相伴
import PersonalCenter from './components/personalCenter'  //个人中心
import { props } from 'bluebird';
import { ApiCore } from '../../../api';
const api = new ApiCore();



const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_3398857_n42sdpi8bt.js', // 在 iconfont.cn 上生成
});


const Home = () => {

    const [activeKey, setActiveKey] = useState<string>('')
    const [userMenus, setUserMenus] = useState<any>([])


    const tabs = [
        {
            key: 'home',
            title: '首页',
            icon: (active: any) => active ? <MyIcon type="icon-active-patient_home" /> : <MyIcon type="icon-patient_home" />
        },
        {
            key: 'tools',
            title: '自测工具',
            icon: (active: any) => active ? <MyIcon type="icon-active-patient_tools" /> : <MyIcon type="icon-patient_tools" />
        },
        {
            key: 'personalCenter',
            title: '个人中心',
            icon: (active: any) => (active ? <MyIcon type="icon-active-patient_personal" /> : <MyIcon type="icon-patient_personal" />)
        }
    ]

    useEffect(() => {
        getMenus()
    }, [])



    const getMenus = () => {
        api.GetMenus({ type: 'MNAV' }).then((res: any) => {
            if (res.code == 0) {
                let menus: any = [], activeKey = '';
                res.data[0].children.forEach((v: any, i: number) => {
                    menus.push({
                        key: v.icon,
                        title: v.name,
                        icon: (active: any) => (active ? <MyIcon type={`icon-active-${v.icon}`} /> : <MyIcon type={`icon-${v.icon}`} />)

                    })
                    if (i == 0) {
                        activeKey = v.icon
                    }
                })
                setActiveKey(activeKey)
                setUserMenus(menus)
            }
        })
    }



    const changeActive = (activeKey: any) => {
        setActiveKey(activeKey)
        // props.history.push('/home#' + activeKey)
    }


    return (
        <div className={styles.homeContainer}>
            {userMenus.length > 0 && <div className={styles.content}>
                {activeKey === userMenus[0].key && <HomeContainer {...props} changeActive={changeActive} />}
                {activeKey === userMenus[1].key && <Tools {...props} changeActive={changeActive} />}
                {activeKey === userMenus[2].key && <PersonalCenter {...props} changeActive={changeActive} />}
            </div>}

            <div className={styles.tabbar}>
                <TabBar activeKey={activeKey} onChange={changeActive}>
                    {userMenus.map((item: any) => (
                        <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
                    ))}
                </TabBar>
            </div>
        </div>
    )
}

export default Home
